"use strict";

var FullTextSearchService = function() {
    // private functions/vars
    var searchedTextHolder;
    var correctedSearchText;
    var timer;
    var autoSuggestionTimeoutId;

    overrideArrayProcessing();
    var triggerSearch = function(searchText) {
        toggleLoadingGif(true);
        searchText = encodeURIComponent(searchText);
        $.ajax({
            method: "GET",
            url: "/search-ajax",
            data: {q: searchText}
        }).done(function (ajaxResult) {
            searchedTextHolder = searchText;
            correctedSearchText = ajaxResult["correctedSearchText"];
            populateSearchPopup(ajaxResult["fullTextSearchAjaxLinkDTOGroupList"]);
            toggleLoadingGif(false);
            $(".ftr-prod").on("mouseenter", function () {
                var $popupItems = $("#ftr-list li").not(".disabled")
                    .not(".ftr-prod-hidden")
                    .not(".ftr-prod-show-more")
                    .not(".ftr-prod-show-less");
                $popupItems.removeData("selected");
                $popupItems.removeClass("hover");
            });
        });
    };

    var populateSearchPopup = function(ajaxDTOList) {
        var $popup = $("#searchPopup");
        var $fullTextResultsList = $("#ftr-list");
        var templateHtml = $("#ftr-prod-li-template").html();
        var showMoreTemplateHtml = $("#ftr-show-more-li-template").html();
        var showLessTemplateHtml = $("#ftr-show-less-li-template").html();
        var listHtml = $("#ftr-no-results").html();

        $fullTextResultsList.empty();
        if (!isEmptyAjaxDTOList(ajaxDTOList)) {
            listHtml = "";
            for (var i = 0; i < ajaxDTOList.length; i++) {
                var LinkGroup = ajaxDTOList[i];
                if (LinkGroup["list"] !== null && LinkGroup["list"].length !== 0) {
                    var initialListSize = LinkGroup["initialListSize"];
                    listHtml += "<li class='ftr-prod disabled'>" + LinkGroup["label"] + "</li>";
                    var showMoreAppended = false;
                    for (var j = 0; j < LinkGroup["list"].length; j++) {
                        if (!showMoreAppended && j >= initialListSize) {
                            listHtml += showMoreTemplateHtml;
                            showMoreAppended = true;
                        }
                        var imageUrl = LinkGroup["list"][j]["imageUrl"];
                        listHtml += templateHtml
                            .replace(/{{link}}/g, LinkGroup["list"][j]["url"])
                            .replace(/{{name}}/g, highlightWord(LinkGroup["list"][j]["label"]))
                            .replace(/{{image}}/g, imageUrl ? '<img alt="" src="' + imageUrl + '">' : '')
                            .replace(/{{iconClass}}/g, LinkGroup["list"][j]["iconClass"])
                            .replace(/{{ftrProdExtraClass}}/g, (j < initialListSize) ? '' : 'ftr-prod-hidden');
                    }
                    if (LinkGroup["list"].length > initialListSize) {
                        listHtml += showLessTemplateHtml;
                    }
                }
            }
        }
        $fullTextResultsList.html(listHtml); // removed concatenation with allResultsHtml, enable when requested
        removeMissingImages($fullTextResultsList);
        handleShowMore($fullTextResultsList);
        handleShowLess($fullTextResultsList);
        $popup.show();
    };

    var isEmptyAjaxDTOList = function(ajaxDTOList) {
        var emptyGroupCount = 0;
        var listLength = ajaxDTOList.length;

        if (listLength <= 0) {
            return true;
        }

        for (var i = 0; i < ajaxDTOList.length; i++) {
            var LinkGroup = ajaxDTOList[i];
            if (LinkGroup["list"].length === 0) {
                emptyGroupCount++;
            }
        }

        return emptyGroupCount === listLength;
    };

    var highlightWord = function(fullText) {
        var returnString = fullText;
        var words = Array.from(new Set(decodeURIComponent(searchedTextHolder).toLowerCase().split(/[\s\/-]+/)))
            .sort(function(s1, s2){ return s2.length - s1.length;});
        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            if (word.length > 0) {
                var found = false;
                var startPosition = 0;
                do {
                    var start = returnString.toLowerCase().indexOf(word, startPosition);
                    var end = start + word.length;
                    if (start >= 0) {
                        found = true;
                        if (isIndexInsideTag(start, returnString, "<b>", "</b>")) {
                            startPosition++;
                        } else {
                            startPosition = end + 7;
                            returnString = returnString.substring(0, start) + "<b>" + returnString.substring(start, end) + "</b>" + returnString.substring(end);
                        }
                    } else {
                        found = false;
                    }
                } while (found && end < returnString.length);
            }
        }

        return returnString;
    };

    var isIndexInsideTag = function(idx, text, tagStart, tagEnd) {
        var found = true;
        var startPosition = 0;
        var tagStartLength = tagStart.length;
        var tagEndLength = tagEnd.length;
        do {
            var start = text.indexOf(tagStart, startPosition);
            if (start >= 0) {
                found = true;
                var end = text.indexOf(tagEnd, start + tagStartLength) + tagEndLength - 1;
                if (idx >= start && idx <= end) {
                    return true;
                }
                startPosition = end;
            } else {
                found = false;
            }
        } while (found);
        return false;
    };

    var clearPopupItems = function($popupItems) {
        $popupItems.removeData("selected");
        $popupItems.removeClass("hover");
    };

    var selectItem = function($correctLi) {
        $correctLi.data("selected", true);
        $correctLi.addClass("hover");
    };

    var findSelected = function($popupItems) {
        var selectedIndex = -1;
        $popupItems.each(function(index) {
            if ($(this).data('selected')) {
                selectedIndex = index;
            }
        });
        return selectedIndex;
    };

    var findCorrectSelectedLi = function($popupItems, next) {
        var selectedIndex = findSelected($popupItems);
        var container = $("#ftr-list");
        if (selectedIndex < 0) {
            container.scrollTop(0);
            return $($popupItems[0]);
        }

        var containerHeight = container.height();
        var containerScrolledTo = container.scrollTop();

        var popupItem;
        var currentSelectionPosition;
        if (next) {
            if(selectedIndex === ($popupItems.length - 1)) {
                selectedIndex = -1;
                container.scrollTop(0);
            }
            popupItem = $($popupItems[selectedIndex + 1]);

            currentSelectionPosition = $(popupItem).position().top;
            if(currentSelectionPosition + popupItem.height() - containerHeight > 0) {
                container.scrollTop(containerScrolledTo + currentSelectionPosition - popupItem.height());
            }
            return popupItem;
        } else {
            if(selectedIndex === 0) {
                selectedIndex = $popupItems.length;
                container.scrollTop($($popupItems[selectedIndex - 1]).position().top);
            }
            popupItem = $($popupItems[selectedIndex - 1]);
            currentSelectionPosition = $(popupItem).position().top;
            if(currentSelectionPosition < 0) {
                container.scrollTop(containerScrolledTo - containerHeight + popupItem.height());
            }
            return popupItem;
        }
    };

    var toggleLoadingGif = function(show) {
        var $loading = $(".search-form-wrapper #loading-icon");
        if (show) {
            $loading.show();
        } else {
            $loading.hide();
        }
    };

    var removeMissingImages = function($fullTextResultsList) {
        $("span.thumb:not(.thumb-icon) > img[src='']", $fullTextResultsList).each(function() {
            $(this).parent().remove();
        });
        $("span.thumb.thumb-icon > img[src='']", $fullTextResultsList).each(function() {
            $(this).remove();
        });
    };

    var handleShowMore = function($fullTextResultsList) {
        $(".ftr-prod-show-more", $fullTextResultsList).on('click', function() {
            $(this).addClass("ftr-prod-hidden");
            $(this).nextUntil(".ftr-prod-show-less").removeClass("ftr-prod-hidden");
            $(this).nextAll(".ftr-prod-show-less:first").removeClass("ftr-prod-hidden");
        });
    };

    var handleShowLess = function($fullTextResultsList) {
        $(".ftr-prod-show-less", $fullTextResultsList).on('click', function() {
            $(this).addClass("ftr-prod-hidden");
            $(this).prevUntil(".ftr-prod-show-more").addClass("ftr-prod-hidden");
            $(this).prevAll(".ftr-prod-show-more:first").removeClass("ftr-prod-hidden");
        });
    };

    function overrideArrayProcessing() {
        // Production steps of ECMA-262, Edition 6, 22.1.2.1
        if (!Array.from) {
            Array.from = (function () {
                var toStr = Object.prototype.toString;
                var isCallable = function (fn) {
                    return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
                };
                var toInteger = function (value) {
                    var number = Number(value);
                    if (isNaN(number)) { return 0; }
                    if (number === 0 || !isFinite(number)) { return number; }
                    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
                };
                var maxSafeInteger = Math.pow(2, 53) - 1;
                var toLength = function (value) {
                    var len = toInteger(value);
                    return Math.min(Math.max(len, 0), maxSafeInteger);
                };

                // The length property of the from method is 1.
                return function from(arrayLike/*, mapFn, thisArg */) {
                    // 1. Let C be the this value.
                    var C = this;

                    // 2. Let items be ToObject(arrayLike).
                    var items = Object(arrayLike);

                    // 3. ReturnIfAbrupt(items).
                    if (arrayLike == null) {
                        throw new TypeError('Array.from requires an array-like object - not null or undefined');
                    }

                    // 4. If mapfn is undefined, then let mapping be false.
                    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                    var T;
                    if (typeof mapFn !== 'undefined') {
                        // 5. else
                        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                        if (!isCallable(mapFn)) {
                            throw new TypeError('Array.from: when provided, the second argument must be a function');
                        }

                        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                        if (arguments.length > 2) {
                            T = arguments[2];
                        }
                    }

                    // 10. Let lenValue be Get(items, "length").
                    // 11. Let len be ToLength(lenValue).
                    var len = toLength(items.length);

                    // 13. If IsConstructor(C) is true, then
                    // 13. a. Let A be the result of calling the [[Construct]] internal method
                    // of C with an argument list containing the single item len.
                    // 14. a. Else, Let A be ArrayCreate(len).
                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);

                    // 16. Let k be 0.
                    var k = 0;
                    // 17. Repeat, while k < len… (also steps a - h)
                    var kValue;
                    while (k < len) {
                        kValue = items[k];
                        if (mapFn) {
                            A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                        } else {
                            A[k] = kValue;
                        }
                        k += 1;
                    }
                    // 18. Let putStatus be Put(A, "length", len, true).
                    A.length = len;
                    // 20. Return A.
                    return A;
                };
            }());
        }
    };

    var stopSearchTextAutoSuggestion = function () {
        if (autoSuggestionTimeoutId) {
            $("#fullTextSearchForm #fullTextSearch").val("");
            clearTimeout(autoSuggestionTimeoutId);
            autoSuggestionTimeoutId = 0;
        }
    };

    var startSearchTextAutoSuggestion = function () {
        var input = $("#fullTextSearchForm #fullTextSearch");
        if (!input.length) {
            return;
        }

        var words = $("input[name=full-text-search-suggestion]").map(function (index, element) {
            return $(element).val();
        }).get();

        var wordsArrayLength = words.length;
        if (!wordsArrayLength) {
            return;
        }

        var writeSpeed = 100;
        var removeSpeed = 50;
        var writeDelay = 500;
        var removeDelay = 1000;

        var removeWord = function (wordIndex, letterIndex) {
            letterIndex--;
            if (letterIndex >= 0) {
                var word = words[wordIndex];
                var inputString = word.substr(0, letterIndex) + " |";
                input.val(inputString);
                autoSuggestionTimeoutId = setTimeout(removeWord, removeSpeed, wordIndex, letterIndex);
                return;
            }

            wordIndex++;
            if (wordIndex === wordsArrayLength) {
                wordIndex = 0;
            }

            letterIndex = 1;
            input.val("|");
            autoSuggestionTimeoutId = setTimeout(writeWord, writeDelay, wordIndex, letterIndex);
        };

        var writeWord = function (wordIndex, letterIndex) {
            var word = words[wordIndex];
            if (letterIndex <= word.length) {
                var inputString = word.substr(0, letterIndex) + " |";
                input.val(inputString);
                letterIndex++;
                autoSuggestionTimeoutId = setTimeout(writeWord, writeSpeed, wordIndex, letterIndex);
                return;
            }

            autoSuggestionTimeoutId = setTimeout(removeWord, removeDelay, wordIndex, letterIndex);
        };

        var wordIndex = 0;
        var letterIndex = 1;
        input.val("|");

        writeWord(wordIndex, letterIndex);
    };

    var handleFullTextSearchSubmit = function () {
        var $popupItems = $("#ftr-list li");
        handleFullTextSearchSubmitByItems($popupItems);
    };

    var handleFullTextSearchSubmitByItems = function ($popupItems) {
        var selectedLiIndex = findSelected($popupItems);
        if (selectedLiIndex >= 0) {
            window.location = $($popupItems[selectedLiIndex]).find('a').attr('href');
        } else {
            if (correctedSearchText !== null && correctedSearchText !== '') {
                $("#fullTextSearchForm #fullTextSearchCorrected").val(correctedSearchText);
            } else {
                $("#fullTextSearchForm #fullTextSearchCorrected").val($("#fullTextSearchForm #fullTextSearch").val());
            }
            stopSearchTextAutoSuggestion();
            $("#fullTextSearchForm").trigger('submit');
        }
    };

    // public functions/vars
    return {
        handleKeyup : function($this) {
            var searchText = $this.val();
            clearTimeout(timer);
            if (searchText.length >= 2 && searchedTextHolder !== searchText) {
                timer = setTimeout(function() { triggerSearch(searchText)}, 500 );
            }
        },

        handleFocus : function() {
            if ($("#ftr-list").text().length > 0) {
                $("#searchPopup").show();
            }

            stopSearchTextAutoSuggestion();
        },

        togglePopup : function(event) {
            var $searchWrapper = $("#fullTextSearch");
            var $popup = $("#searchPopup");

            if ($popup.is(":visible")) {
                if ((!$searchWrapper.is(event.target) && $searchWrapper.has(event.target).length === 0)
                        && (!$popup.is(event.target) && $popup.has(event.target).length === 0)) {
                    $popup.hide();
                    $searchWrapper.trigger("blur");
                }
            }
        },

        togglePopupSelect : function(event) {
            var $popup = $("#searchPopup");
            var $popupItems = $("#ftr-list li").not(".disabled")
                .not(".ftr-prod-hidden")
                .not(".ftr-prod-show-more")
                .not(".ftr-prod-show-less");
            var $correctLi;

            if ($popup.is(":visible")) {
                switch (event.key) {
                    case "ArrowDown":
                        $correctLi = findCorrectSelectedLi($popupItems, true);
                        clearPopupItems($popupItems);
                        selectItem($correctLi);
                        event.preventDefault();
                        break;
                    case "ArrowUp":
                        $correctLi = findCorrectSelectedLi($popupItems, false);
                        clearPopupItems($popupItems);
                        selectItem($correctLi);
                        event.preventDefault();
                        break;
                    case "Enter":
                        handleFullTextSearchSubmitByItems($popupItems);
                        event.preventDefault();
                        break;
                    case "Escape":
                        $popup.hide();
                        clearPopupItems($popupItems);
                        event.preventDefault();
                        break;
                }
                return;
            }

            if (event.key === "Enter") {
                event.preventDefault();
            }
        },

        handleEventsOnFullTextSearchForm: function (event) {
            var $searchButton = $('#searchButton');
            var inputValue = event.target.value;

            if ($searchButton.length && (inputValue.length > 0 || $searchButton.hasClass("search-button-active"))) {
                $searchButton.prop("disabled", false);
            } else {
                $searchButton.prop("disabled", true);
            }
        },

        handleClickSearchToggle: function ($this) {
            var $fullTextSearchForm = $('#fullTextSearchForm');
            var $searchWrapper = $this.closest('.search-form-wrapper');
            $this.toggleClass("active");

            if ($searchWrapper.length) {
                $searchWrapper.toggleClass("active");
            }

            if ($fullTextSearchForm.length) {
                $fullTextSearchForm.toggleClass("active");
            }
        },

        handleFullTextSearchSubmit: handleFullTextSearchSubmit,
        stopSearchTextAutoSuggestion: stopSearchTextAutoSuggestion,
        startSearchTextAutoSuggestion: startSearchTextAutoSuggestion,
        correctedSearchText: correctedSearchText
    };
};